import React from 'react';
import querystring from 'querystring';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop } from 'components/Panel';
import { Table, Th, Td } from 'components/Table';
import PlayerLink from 'components/PlayerLink';
import NumberInput from 'components/NumberInput';
import { dp } from 'components/util';

export default class BattingAveragesPage extends React.Component {
    componentDidMount() {
        if (window !== undefined) {
            window.addEventListener('popstate', event => {
                let params = {};
                if (window.location.search) {
                    params = querystring.parse(window.location.search.substring(1));
                }
                this.props.browserBack(window.location.pathname, params);
            });
        }
    }

    render() {
        const { averages, innings, sort, sortColumn, filterInnings } = this.props;
        return (
            <Main>
                <MainHeader />
                <Body id="batting-averages-page">
                    <Panel border>
                        <PanelTop title="Batting Averages" buttons>
                            <NumberInput ref="innings" id="innings-input" label="Minimum Innings" value={innings} onSave={filterInnings} />
                        </PanelTop>
                        <BattingAveragesTable averages={averages} sort={sort} sortColumn={sortColumn} />
                    </Panel>
                </Body>
            </Main>
        );
    }
}

const BattingAveragesTable = ({ averages, sort, sortColumn }) => (
    <Table striped hover>
        <thead>
            <tr>
                <Th min="8" />
                <Th left>Name</Th>
                <Th sortable min="2" id="runs" sort={sort} onSort={sortColumn}>
                    Runs
                </Th>
                <Th sortable priority="2" id="maxruns" sort={sort} onSort={sortColumn}>
                    Best
                </Th>
                <Th sortable priority="2" id="r100s" sort={sort} onSort={sortColumn}>
                    100s
                </Th>
                <Th sortable priority="2" id="r50s" sort={sort} onSort={sortColumn}>
                    50s
                </Th>
                <Th sortable short="3" value="Inns" id="innings" sort={sort} onSort={sortColumn}>
                    Innings
                </Th>
                <Th sortable priority="2" short="3" value="No" id="notouts" sort={sort} onSort={sortColumn}>
                    Not Outs
                </Th>
                <Th sortable min="2" short="2" value="Avg" id="average" sort={sort} onSort={sortColumn}>
                    Average
                </Th>
            </tr>
        </thead>
        <tbody>{averages.map((row, index) => <BattingAveragesRow key={row.pid} index={index} row={row} />)}</tbody>
    </Table>
);

const BattingAveragesRow = ({ row, index }) => (
    <tr>
        <Td min="8">{index + 1}</Td>
        <Td left>
            <PlayerLink pid={row.pid} fname={row.fname} lname={row.lname} />
        </Td>
        <Td sortable min="2">
            {row.runs}
        </Td>
        <Td sortable priority="2" className={`cc-runs-${row.bestisout.toLowerCase().replace(' ', '_')}`}>
            {row.bestruns}
        </Td>
        <Td sortable priority="2">
            {row.r100s}
        </Td>
        <Td sortable priority="2">
            {row.r50s}
        </Td>
        <Td sortable>{row.innings}</Td>
        <Td sortable priority="2">
            {row.notouts}
        </Td>
        <Td sortable min="2">
            {dp(row.average)}
        </Td>
    </tr>
);



// WEBPACK FOOTER //
// ./src/views/batting-averages/BattingAveragesPage.jsx